import { InjectionToken } from '@angular/core';

/** SVG icon API config (aligned with Lit `SvgIconLoader`). `hostUrl` may include `{apiVersion}` replaced by {@link SVG_ICON_DOMAIN_NUMBER_STR}. */
export type SvgIconConfig = {
  brand: string;
  hostUrl: string;
};

// biome-ignore lint/style/useNamingConvention: InjectionToken must be this way
export const SVG_ICON_CONFIG: InjectionToken<SvgIconConfig> = new InjectionToken<SvgIconConfig>('SVG_ICON_CONFIG');

/** API path segment (e.g. version id) substituted for `{apiVersion}` in `hostUrl`. */

// biome-ignore lint/style/useNamingConvention: InjectionToken must be this way
export const SVG_ICON_DOMAIN_NUMBER_STR: InjectionToken<string> = new InjectionToken<string>(
  'SVG_ICON_DOMAIN_NUMBER_STR'
);

export function buildSvgIconImageUrl(
  svgImagePath: string,
  svgIconConfig: SvgIconConfig,
  domainNumberStr: string
): string {
  const url: string = svgIconConfig.hostUrl.replace('{apiVersion}', domainNumberStr);
  return `${url}get-svg-icon/?${svgImagePath}`;
}
